import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {OfferCardDataDriver} from "../offer-card-data.model";

@Component({
  selector: 'offer-drivers',
  template: `
    <div class="offer-card-benefits-container" *ngIf="drivers && drivers.length > 0">
      <ul class="offer-card-benefits">
        <li *ngFor="let driver of drivers" class="offer-card-benefit-item">
          <tooltip backgroundColor="-white" position='-top -right' [openOnHover]="hasTooltipText(driver)" product="nymeria-gui" flow="landing">
            <span label [class]="getDriverType(driver)" [ngClass]="{'eva-3-driver': this.offerType !== 'DUALTRIP'}">
              <span class="driver-text">
                <i class="-eva-3-mr-xsm eva-3-icon-info-circle"
                    *ngIf="driver.tooltip && driver.tooltip.text"></i>

                <i *ngIf="shouldShowIcon(driver)" 
                    class="-eva-3-mr-xsm eva-3-icon-{{driver.icon}}"></i>
                
                {{driver.text}}

                <div *ngIf="driver.icon === 'hotels' && starsArray" class="offer-card-rating-stars">
                  <i *ngFor="let star of starsArray" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
                </div>
              </span>
            </span>
           
            <p tooltip-content class="tooltip-text">{{driver.tooltip?.text}}</p>
          </tooltip>
        </li>
      </ul>
    </div>
  `,
  styleUrls: ['./offer-drivers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferDriversComponent implements OnInit {
  @Input() drivers: OfferCardDataDriver[];
  @Input() offerType: string;
  @Input() stars: string;

  starsArray: Array<any>;
  isDualTrip: boolean;

  ngOnInit(): void {
    this.isDualTrip = this.offerType === 'DUALTRIP';
    if (this.isDualTrip && this.stars) {
      this.starsArray = Array(parseInt(this.stars));
    }
  }

  shouldShowIcon(driver: OfferCardDataDriver): boolean {
    const hasIcon = !!driver.icon;
    const hasNoTooltipText = !driver.tooltip || !driver.tooltip.text;
    const isHotelIcon = driver.icon === 'hotels';
    const shouldShowIcon = hasIcon && hasNoTooltipText && !isHotelIcon;
    return this.isDualTrip || shouldShowIcon;
  }

  hasTooltipText(driver: OfferCardDataDriver): boolean {
    return !!driver.tooltip?.text;
  }

  getDriverType(driver: OfferCardDataDriver): string {
    if (driver.driver_style) {
      return driver.driver_style;
    }
    // TODO esto se tiene que dejar de usar en los nuevos drivers de eva
    return driver.tooltip && driver.tooltip.text && driver.type !== 'IMPORTANT' ? '-information'
      : driver.type === 'IMPORTANT' ? '-secondary' : driver.type === 'UNBEATABLE' ? '-unbeatable'
        : driver.tooltip && driver.tooltip.text ? '' : '-secondary';
  }
}
